<template>
  <div>
    <p v-if="RetMsg">出现错误：{{RetMsg}}</p>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import storage from "../../common/utils/storage";
export default {
  name: 'HubAuthorize',
  data() {
    return {
      RetMsg: ''
    }
  },
  computed: {
    scope() {
      return this.$route.query.scope;
    },
    openId() {
      return this.$route.query.openId;
    },
    accessToken() {
      return this.$route.query.accessToken;
    }
  },
  created() {
    // 判断微信授权回来
    if(this.openId && this.accessToken) {
      let scope = storage.getStore('scope');
      if (scope == 'snsapi_base') {
        this.setOpenid(this.openId);
        sessionStorage.setItem("Openid", this.openId);
        let lastPath = storage.getStore('lastPath');
        this.$router.replace(lastPath);
      } else { 
        this.$axios.post('/Api/Api_Hub/GetUserInfo', {
          openid: this.openId,
          access_token: this.accessToken
        }).then(res => {
          if (res.RetCode == '200') {
            if (res.Data) {
              sessionStorage.setItem("Openid", res.Data.Openid);
              this.setOpenid(res.Data.Openid);
              this.setUserInfo({userInfo: res.Data});

              let lastPath = storage.getStore('lastPath');
              if(lastPath == '/register') {
                this.$axios.get('/Api/Api/Web/GetWxUser/GetCIAM?openid=' + res.Data.Openid).then(res1 => {
                  if (res1.RetCode == '10000' && res1.Data) {
                    this.$router.push('/publicRegister');
                  } else {
                    this.$router.push('/register');
                  }
                })
              } else {
                this.$router.push(lastPath);
              }
            }
          } else {
            this.RetMsg = res.RetMsg;
            this.$toast(res.RetMsg);
          }
        })
      }
    } else {
      this.getAuthCode();
    }
  },
  methods: {
    ...mapActions(['setOpenid', 'setUserInfo']),
    getAuthCode() {
      // this.$axios.get('/Api/Api_Hub/Hub_wxToken?scope=' + this.scope).then(res => {
      //   // location.href = res.Data;
      // })
      location.href =`https://dmall.jjmc.cn/ea/hub/redirect/auth?appId=wxfee51244ec734f73&scope=${this.scope}&returnUrl=https://jpublicmon.jjmc.cn/hubAuthorize`
    }
  }
}
</script>